<template>
    <listReportsComponent/>
</template>

<script>
import listReportsComponent from "@/views/reports/pages/list_reports/components/list_reports_component.vue"
export default {
    name: "reports",
    components: {
        listReportsComponent
    },
}
</script>

<style lang="css" scoped>
</style>